import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function openCenterCosts(id: number) {
  return restApiClient.url(constructApiUrl(API.centers.openCenterCosts.url, { id })).post()
}
